import DashboardIcon from "@mui/icons-material/Dashboard";
import SettingsIcon from "@mui/icons-material/Settings";
import InsightsIcon from "@mui/icons-material/Insights";
import PlaceIcon from "@mui/icons-material/Place";
import ShowChartIcon from "@mui/icons-material/ShowChart";
import StorageIcon from "@mui/icons-material/Storage";
import DevicesIcon from "@mui/icons-material/Devices";
import NotificationsIcon from "@mui/icons-material/Notifications";
import EventIcon from "@mui/icons-material/Event";
import PeopleAltIcon from "@mui/icons-material/PeopleAlt";
import ManageAccountsIcon from "@mui/icons-material/ManageAccounts";
import SettingsSuggestIcon from "@mui/icons-material/SettingsSuggest";
import SummarizeIcon from "@mui/icons-material/Summarize";
import AlarmIcon from "@mui/icons-material/Alarm";
import AdminPanelSettingsIcon from "@mui/icons-material/AdminPanelSettings";
import DashboardCustomizeIcon from "@mui/icons-material/DashboardCustomize";

import React from "react";
import { DashboardCustomizeTwoTone } from "@mui/icons-material";

export const menu = [
  /*{
    icon: <DashboardIcon style={{ color: "#0A6073", fontSize: "32px" }} />,
    title: "Dashboard",
    to: "/admin/dashboard",
    level: "parent",
    color: "#000",
  },
 
  {
    icon: <InsightsIcon style={{ color: "#0A6073", fontSize: "32px" }} />,
    title: "Analytics",
    level: "parent",
    color: "#000",
    items: [
      {
        icon: <DevicesIcon style={{ color: "#0A6073", fontSize: "24px" }} />,
        title: "System Status",
        to: "/admin/systemstatus",
        level: "child",
        color: "#000",
      },
      {
        icon: <StorageIcon style={{ color: "#0A6073", fontSize: "24px" }} />,
        title: "Data Overview",
        to: "/admin/dataoverview",
        level: "child",
        color: "#000",
      },
      {
        icon: <ShowChartIcon style={{ color: "#0A6073", fontSize: "24px" }} />,
        title: "Charts Insights",
        to: "/admin/chartinsights",
        level: "child",
        color: "#000",
      },
      {
        icon: (
          <NotificationsIcon style={{ color: "#0A6073", fontSize: "24px" }} />
        ),
        title: "Alarms History",
        to: "/admin/alarmshistory",
        level: "child",
        color: "#000",
      },
       
    ],
  },
  
  {
    icon: <SettingsIcon style={{ color: "#0A6073", fontSize: "32px" }} />,
    title: "Settings",
    level: "parent",
    color: "#000",
    role:"admin",
    items: [
      // {
      //   icon: <PeopleAltIcon style={{ color: "#0A6073", fontSize: "24px" }} />,
      //   title: "User Management",
      //   to: "/admin/usermanagement",
      //   level: "child",
      //   color: "#000",
      //   role:"admin",
      // },
      {
        icon: (
          <ManageAccountsIcon style={{ color: "#0A6073", fontSize: "24px" }} />
        ),
        title: "Tenant Management",
        to: "/admin/tenant/list",
        level: "child",
        color: "#000",
        role:"admin",
      },
      {
        icon: (
          <SettingsSuggestIcon style={{ color: "#0A6073", fontSize: "24px" }} />
        ),
        title: "Parameter",
        to: "/admin/parameters/list",
        level: "child",
        color: "#000",
        role:"admin",
      },
      // {
      //   icon: <SummarizeIcon style={{ color: "#0A6073", fontSize: "24px" }} />,
      //   title: "Reports",
      //   to: "/admin/reports",
      //   level: "child",
      //   color: "#000",
      //   role:"admin",
      // },
      // {
      //   icon: <AlarmIcon style={{ color: "#0A6073", fontSize: "24px" }} />,
      //   title: "Alerts",
      //   to: "/admin/alerts",
      //   level: "child",
      //   color: "#000",
      //   role:"admin",
      // },
      {
        icon: (
          <DashboardCustomizeIcon
            style={{ color: "#0A6073", fontSize: "24px" }}
          />
        ),
        title: "Dashboard",
        to: "/admin/dashboardmanagement",
        level: "child",
        color: "#000",
        role:"admin",
      },
      {
        icon: (
          <DashboardCustomizeTwoTone style={{ color: "#0A6073", fontSize: "24px" }} />
        ),
        title: "Image Parameters",
        role:"admin",
        to: "/admin/imageparameters",
        level: "child",
        color: "#000",
      },
    ],
  },*/
  {
    icon: <PlaceIcon style={{ color: "#0A6073", fontSize: "32px" }} />,
    title: "Maps",
    to: "/admin/maps",
    color: "#000",
  },
  /*
  {
    icon: (
      <AdminPanelSettingsIcon style={{ color: "#0A6073", fontSize: "32px" }} />
    ),
    title: "Admin",
    role:"admin",
    to: "adminportal",
    type: "link",
    color: "#000",
  },*/
  {
    icon: <SettingsIcon style={{ color: "#0A6073", fontSize: "32px" }} />,
    title: "Maintenance",
    level: "parent",
    color: "#000",
    role: "admin",
    items: [
      {
        icon: <EventIcon style={{ color: "#0A6073", fontSize: "24px" }} />,
        title: "Work Order Management",
        to: "/admin/workorder/list",
        level: "child",
        color: "#000",
      },
      /*
      {
        icon: <EventIcon style={{ color: "#0A6073", fontSize: "24px" }} />,
        title: "MaintenanceCalender",
        to: "/admin/workorder/schedule",
        level: "child",
        color: "#000",
      },
   
      {
        icon: <EventIcon style={{ color: "#0A6073", fontSize: "24px" }} />,
        title: "Work Order Form",
        to: "/admin/workorderform",
        level: "child",
        color: "#000",
      },*/
    ],
  },
];
